export default __webpack_public_path__ + "static/media/notificationCloseIcon.bfcb6ea1.svg";